import React from "react";
import Layout, { MyLocationEnum } from "../components/Layout";
import Event from "../components/Event/Event";
import SEO from "../components/Seo";

const event = ({ pageContext, location, navigate, ...rest }) => {
  
  return (
    <Layout myLocation={MyLocationEnum.Speaker} location={location}>
      
        <SEO title="Viðburður" description="Upplýsingar um viðburð"/>

        <Event event={pageContext.speaker}></Event>
      
    </Layout>
  );
};

export default event;
